import { apiRequest } from '@/utils/api-request';

export interface DeleteWorkflowResponse {
  data?: {
    success?: boolean;
    message?: string;
    workflow_id?: string;
    name?: string;
    description?: string;
    publish_to_template?: boolean;
    node_count?: number;
    edge_count?: number;
    created_at?: string;
    updated_at?: string;
    created_by?: string;
    created_by_email?: string;
    created_by_name?: string;
    orgid?: string;
    workflow?: {
      workflow_id?: string;
      name?: string;
      description?: string;
      payload?: unknown;
      created_at?: string;
      updated_at?: string;
      created_by?: string;
      created_by_email?: string;
      created_by_name?: string;
      publish_to_template?: boolean;
    };
  };
  detail?: string;
}

/**
 * Fetches a workflow data by organization ID and workflow ID from the backend.
 * @returns Promise containing the workflow data.
 */
export async function deleteWorkflow(
  workflowId: string,
  orgId: string,
): Promise<DeleteWorkflowResponse> {
  const response = await apiRequest<DeleteWorkflowResponse>({
    url: `/api/v1/orgs/${orgId}/workflows/${workflowId}`,
    target: 'workflow',
    method: 'DELETE',
  });

  if (response?.detail) {
    // Check if the error indicates a permission/403 error
    const errorMessage = response.detail.toLowerCase();
    if (
      errorMessage.includes('forbidden') ||
      errorMessage.includes('permission') ||
      errorMessage.includes('not authorized') ||
      errorMessage.includes('unauthorized')
    ) {
      throw new Error("You don't have permission to delete workflow");
    }
    throw new Error(response.detail || 'Failed to delete workflow');
  }

  return response as DeleteWorkflowResponse;
}
